import Vue from "vue";
import Vuex from "vuex";
import createMutationsSharer from "vuex-shared-mutations";

import authModule from "./auth";
import sensorModule from "./sensors";
import userModule from "./users";

const modules = {
  auth: authModule,
  sensors: sensorModule,
  users: userModule,
};

const predicates = [];
Object.keys(modules).forEach((module) => {
  Object.keys(modules[module].mutations).forEach((mutation) => {
    predicates.push(module + "/" + mutation);
  });
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules,
  plugins: [
    createMutationsSharer({
      predicate: predicates,
    }),
  ],
});
